import React, { useEffect, useState, createContext, useContext } from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory as createHistory } from 'history'
// import { Provider, useDispatch, useSelector } from 'react-redux'
import { Admin, Resource } from 'react-admin'
// import { Provider } from 'react-redux'
// import store from './assets/redux/store'
// import simpleRestProvider from 'ra-data-simple-rest'
import DataProvider from './DataProvider'

import { VideoList, VideoEdit, VideoCreate, VideoIcon } from './Views/Videos'
import { Home, HomeIcon } from './Views/Home'
// import useQuery from '../assets/functions/useQuery'

// import filesToUploads from './assets/redux/reducers/filesToUploads'
// import filesForUploads from './DataProvider/filesForUploads'
// const history = createHistory({ basename: '/rezoprog' })

function AdminVdo({ goto = null }) {
  // const query = useQuery()

  // const SendFilesList = useSelector(filesToUploads)
  const history = createHistory({ basename: window.variables.basename })

  useEffect(async () => {
    if (goto) {
      history.push(`/${goto}`)
    }
  }, [])

  const authProvider = {
    // authentication
    login: (params) => Promise.resolve(),
    checkError: (error) => Promise.resolve(),
    checkAuth: (params) => Promise.resolve(),
    logout: () =>
      window.location.replace(
        `${window.variables.urlSite}/wp-login.php?action=logout`
      ),
    getIdentity: () => Promise.resolve(),
    // authorization
    getPermissions: (params) => Promise.resolve()
  }

  console.log('test')

  return (
    <div
      style={{ position: 'absolute', top: 0, right: 0, left: 0, zIndex: 999 }}>
      <Admin
        authProvider={authProvider}
        dataProvider={DataProvider}
        history={history}>
        <Resource
          name='Accueil'
          list={Home}
          // create={PostCreate}
          icon={HomeIcon}
        />
        <Resource
          options={{ label: 'Vidéos' }}
          name='video-tandem'
          list={VideoList}
          edit={VideoEdit}
          // create={VideoCreate}
          icon={VideoIcon}
        />
      </Admin>
    </div>
  )
}

function App() {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const redirect = urlParams.get('redirect')
  const id = urlParams.get('id')

  // console.log(queryString, id, redirect, urlParams, code, locationid)
  // console.log(code, locationid)
  return (
    <AdminVdo goto={queryString ? `${redirect}${id ? `/${id}` : ''}` : null} />
  )
}

ReactDOM.render(<App />, document.getElementById('vdo_admin_root'))
